<template>
    <div style="overflow-x: auto; border-radius: 10px; max-width: 50%;">
        <table>
           <!--  <caption class="table-header">{{ this.$t('tabs.gas_swap') }}</caption> -->
            <thead>
              <tr>
                <th class="encabezado" ></th>
                <th class="encabezado" >Swap 1</th>
                <th class="encabezado" >Swap 2</th>
                <th class="encabezado" >Swap 3</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(label, index) in label_resumido" :key="index" class="tabla-hover">
                <td class="primera_columna">{{ this.$t('tabs.swap.'+label)}}</td>
                <td>
                    <input type="number" v-model.number="parametros[0][label]" 
                    @input="emitChanges"
                    style="padding-left: 45% !important;"
                    step="0.1"/>
                </td>
                <td>
                    <input type="number" v-model.number="parametros[1][label]" 
                    @input="emitChanges"
                    style="padding-left: 45% !important;"
                    step="0.1"/>
                </td>
                <td>
                    <input type="number" v-model.number="parametros[2][label]" 
                    @input="emitChanges"
                    style="padding-left: 45% !important;"
                    step="0.1"
                    />
                </td>
            </tr>
              
            </tbody>
          </table>
    </div>
    </template>
    
    <script>
    export default {
        props:{
            gas_swap:{
                type:Array,
                required:true,
            },
        },
        data(){
                return {
                    parametros:[...this.gas_swap],
                    label_resumido:['cantidad','precio'],
                }
        },
        methods:{
            emitChanges(){
            this.$emit("update:gas_swap", this.parametros);
          },
        },
        watch:{
    
        },
    }
    </script>
    
    <style scoped>
    table {
        width: 100%;
        border-collapse: collapse;
        text-align: center;
      }
      .table-header {
        font-size: 1.5em;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
        color: white;
        background-color: #006699;
      }
      

      .primera_columna{
        background-color: white;
      }
      .valor_fijo{
        background-color: white;
      }

      input[type="number"] {
        width: 100%;
        text-align: center;
        border: none;
        border-radius: 4px;
        color: #024e74;
      }
      
      select {
        width: 100%;
        border: 1px solid #F2F2F2;
        border-radius: 4px;
        text-align: center;
        color: #024e74;
      }
      
      input[disabled] {
        background-color: white;
        color: #024e74;
        cursor: not-allowed;
      }
    
    
    </style>